import type { SVGProps } from "react";
import * as React from "react";

export const CloseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 25"
    className="fill-current"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17.749 8.213a.857.857 0 1 0-1.212-1.212L12 11.538 7.463 7a.857.857 0 0 0-1.212 1.212l4.537 4.537-4.537 4.537a.857.857 0 1 0 1.212 1.212L12 13.962l4.537 4.537a.857.857 0 1 0 1.212-1.212l-4.537-4.537z"
    />
  </svg>
);
